import { useEffect } from "react";
import { useTelegramContext } from "@/contexts/TelegramContext";
import { clientConfig } from "@/lib/config/client-config";
import { backButton } from "@telegram-apps/sdk-react";
import { useRouter, usePathname } from "next/navigation";

export const TelegramBackButton = () => {
  const router = useRouter();
  const pathname = usePathname();
  const { isTMA } = useTelegramContext();

  useEffect(() => {
    if (!isTMA || clientConfig.tmaDev) {
      return;
    }

    if (!backButton) {
      return;
    }
    if (pathname === "/") {
      backButton.hide();
    } else {
      backButton.show();
    }
  }, [backButton, pathname, isTMA]);

  useEffect(() => {
    if (!isTMA || clientConfig.tmaDev) {
      return;
    }

    return backButton && backButton.onClick(router.back);
  }, [backButton, router.back, isTMA]);

  return null;
};
